import { Tooltip } from 'components/ui/tooltip';
import { ReactElement } from 'react';

/**
 * A tooltip whose bubble shows only when there is a reason: an empty one would still draw an empty bubble. The
 * trigger stays wrapped either way, so a reason coming or going does not remount what sits under it.
 */
export function ReasonTooltip({ reason, children }: { reason?: string | null; children: ReactElement }) {
    return (
        <Tooltip content={reason} className={reason ? undefined : 'hidden'}>
            {children}
        </Tooltip>
    );
}
